import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Twitter = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M36,34.946L22.989,17.558l11.57-12.504l-2.816-0.067L21.708,15.85L13.621,5.054L4.067,4.987l12.357,16.574
        L4,35.013h2.816l10.876-11.743l8.754,11.743L36,34.946z M8.257,7.083l4.324,0.067l7.686,10.262l0,0l1.268,1.695l0,0l10.342,13.798 h-4.324l-8.781-11.77l-0.881-1.174l0,0L8.257,7.083z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
